'use strict';

/**
 * @ngdoc function
 * @name thothAppApp.controller:InvoiceShowCtrl
 * @description
 * # InvoiceShowCtrl
 * Controller of the thothAppApp
 */
angular.module('thothApp.controllers')
  .controller('InvoiceShowCtrl', [
  '$scope', '$state', '$stateParams', 'Invoice', '$mdDialog', 'toaster',
  function ($scope, $state, $stateParams, Invoice, $mdDialog, toaster) {
    $scope.invoice = {};
    Invoice.find($stateParams.invoiceId).then(function(response) {
      $scope.invoice = response.data.invoice;
    }, function(error) {
      Invoice.error(error);
    });

    $scope.goBack = function() {
      return $state.go('app.projects.show', {projectId: $stateParams.projectId});
    }

    $scope.changeState = function(event) {
      var currentScrollPosition = window.scrollY;
      $mdDialog.show({
        templateUrl: 'views/invoices/change-state-modal.html',
        locals: {
          invoice: $scope.invoice,
          event: event,
          onRemoving: function() {
            window.scrollTo(0, currentScrollPosition);
          }
        },
        controller: ['$scope', '$mdDialog', 'invoice', 'event', function DialogController($scope, $mdDialog, invoice, event) {
          $scope.commentHash = {
            comment: '',
            date: new Date(),
            folio: null,
            event: event
          };
          $scope.close = function() {
            $mdDialog.hide();
          };

          $scope.cancelInvoice = function() {
            invoice.audit_comment = $scope.commentHash.comment;
            invoice.date_of_invoice = $scope.commentHash.date;
            invoice.state = event.event;
            if($scope.commentHash.folio) {
              invoice.folio = $scope.commentHash.folio;
            }
            Invoice.save({invoice: Invoice.sanitizeParams(invoice)}).then(function(response) {
              $state.reload();
              toaster.pop('success', 'Factura', 'El cambio fue realizado exitosamente');
              $mdDialog.hide();
            }, function(error) {
              Invoice.error(error);
              $mdDialog.hide();
              $state.reload();
            });
          }
        }]
      });
    };
  }]);
